import { get } from "../../api_helper";
import * as url from "../../url_helper";

// Theo dõi hạn chứng chỉ TLS. Chỉ đọc thông tin công khai của chứng chỉ
// (tên miền, ngày hết hạn) — không có chứng chỉ và không có khoá.
// Danh sách tên miền nạp sẵn ở BE, không thêm/xoá từ giao diện.

/** Tình trạng mọi tên miền, kể cả những cái còn hạn dài. */
export const apiGetCertificates = () => get(url.API_TLS_CERTIFICATES);

/** Chỉ những tên miền đang có vấn đề, dùng cho dải cảnh báo. */
export const apiGetCertificateAlerts = () => get(url.API_TLS_CERTIFICATE_ALERTS);
